<template>
  <div class="field">
    <div class="field-name">{{ field.label }}</div>
    <input
      v-if="!field.max_length || field.max_length <= 30"
      v-model="field.value"
      type="text"
      :maxlength="field.max_length"
    />
    <textarea
      v-else
      v-model="field.value"
      class="text-area__form-input"
      :maxlength="field.max_length"
      rows="6"
      @keydown.enter.exact.stop
      @keyup.enter.exact.stop
      @keydown.enter.shift.exact.prevent
    />
  </div>
</template>

<script>
import { EMITTERS } from '../../shared/utils/emitters'

export default {
  name: 'TextFieldComponent',
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  emits: ['update:value', 'change'],
  data() {
    return {
      EMITTERS,
    }
  },
  watch: {
    'field.value'() {
      this.emitValueUpdate()
    },
  },
  methods: {
    emitValueUpdate() {
      this.$emit('change', this.field)
      this.$emit('update:value', this.field)
    },
  },
}
</script>

<style lang="scss" scoped>
.field {
  display: flex;
  align-items: baseline;
  margin-bottom: 20px;
  .field-name {
    width: 150px;
    text-align: right;
    margin-right: 10px;
  }
  input,
  textarea {
    max-width: 250px;
  }
}
</style>
